import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { useCallback } from 'react';
import { coreClientApi } from 'src/entities/client';
import { ClientStatus } from '@common/model/client/status';

export const useToggleClientBan = () => {
  const [ban] = coreClientApi.endpoints.ban.useMutation();
  const [unban] = coreClientApi.endpoints.unban.useMutation();
  const [getClient] = coreClientApi.endpoints.getClient.useLazyQuery();
  return useCallback(
    async (id: ApiServerEntityIDType) => {
      const client = await getClient({ id }).unwrap();
      if (client.status === ClientStatus.Banned) return unban({ id });

      const confirmed = window.confirm('Забанить клиента?');
      if (!confirmed) {
        return;
      }
      return ban({ id });
    },
    [ban, unban, getClient],
  );
};
